function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 427;


//////////////////
// WEBPACK FOOTER
// ./src/assets nonrecursive ^\.\/favicon.(png|jpe?g|svg|ico)$
// module id = 427
// module chunks = 1